var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "object-form-activities-tab-navbar",
        [
          _c(
            "v-btn",
            {
              attrs: { "x-small": "", text: "", icon: "", color: "accent" },
              on: { click: _vm.exitTaskCreate }
            },
            [_c("v-icon", [_vm._v("arrow_back_ios")])],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { staticClass: "subheading font-weight-bold" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("NewTask")) + "\n    ")
          ]),
          _vm._v(" "),
          _c("list-edition-toolbar", {
            attrs: {
              buttons: _vm.toolbarButtons,
              "horizontal-alignment": "right"
            },
            on: { save: _vm.scheduleDateFilled }
          }),
          _vm._v(" "),
          _c("toggle-buttons", {
            staticStyle: { margin: "6px 8px" },
            attrs: { buttons: _vm.toggleButtons },
            model: {
              value: _vm.mode,
              callback: function($$v) {
                _vm.mode = $$v
              },
              expression: "mode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("task-create-form", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mode === "details",
            expression: "mode === 'details'"
          }
        ],
        attrs: {
          "new-task": _vm.newTask,
          "object-layer": _vm.objectLayer,
          objectData: _vm.objectData,
          "dependency-options": _vm.dependenciesOptions
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.warningDialog,
          title: _vm.$t("Warning"),
          content: _vm.$t("TaskWarning"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.warningDialog = false
          },
          secondaryAction: _vm.confirmWarning
        }
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.warningDialogUser,
          title: _vm.$t("Warning"),
          content: _vm.$t("TaskMissingUser"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: {
          mainAction: function($event) {
            _vm.warningDialogUser = false
          },
          secondaryAction: _vm.confirmWarningUser
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6177fe84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6177fe84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskCreate/TaskCreate.vue
// module id = null
// module chunks = 